<template>
  <div>

    <div v-if="$store.state.user.st_tipo == 'S'">
      <p class="alert alert-primary lead">Seja Bem-Vindo ao KLINGO!</p>

      <section class="after-loop" id="modulos">
        <div class="container2">
          <router-link to="/setup/clinica" class="after-loop-item card border-0 card-templates dashcard card-link az-anime-surgir">
            <div class="card-body d-flex align-items-center flex-column text-right text-white atalho"
              style="--height: 400px;" :class="'bg-primary'">
              <i class="fa fa-cogs fa-4x" aria-hidden="true"></i>
              <h3 class="mt-2">Configurações Iniciais</h3>
            </div>
          </router-link>
        </div>
      </section>
    </div>

    <template v-else-if="$store.state.user.st_tipo != 'P' && $store.state.user.st_tipo != 'X' && $store.state.user.st_tipo != 'R' && $store.state.user.st_tipo != 'O'">
      <section class="after-loop" id="modulos">
        <div class="container2">

          <az-input 
            ref="pesquisa"
            class="mb-3"
            icon="fa-solid fa-magnifying-glass fa-fw"
            placeholder="Pesquisar..."
            v-model="search"
            @onEnter="selecao()" />

          <div class="row">
            <div class="col-lg-4 col-md-8 mb-0 mb-lg-0" v-for="(modulo, index) in lista" :key="index">
                <a id="atalho-modulo" href="#" @click.prevent="navegar(modulo)" v-if="modulo.path" class="after-loop-item card border-0 card-templates dashcard card-link az-anime-surgir">
                    <div class="card-body d-flex align-items-center flex-column text-right atalho" style="--height: 380px;" :class="'bg-' + ( tudo_branco ? 'light' : ( modulo.color + ' text-white' ) )">
                        <i :class="modulo.icon" class="fa-4x"></i>
                        <h3 class="mt-2">{{ modulo.title }}</h3>
                    </div>
                </a>

                <a href="#" @click.prevent="modulo.action()" v-else-if="lista && lista.length > 0" class="after-loop-item card border-0 card-templates dashcard card-link az-anime-surgir">
                    <div class="card-body d-flex align-items-center flex-column text-right atalho" style="--height: 380px;" :class="'bg-' + ( tudo_branco ? 'light' : ( modulo.color + ' text-white'  ) )">
                        <i :class="modulo.icon" class="fa-4x"></i>
                        <h3 class="mt-2">{{ modulo.title }}</h3>
                    </div>
                </a>
            </div>
          </div>
        </div>
      </section>

    </template>

    <template v-if="$store.state.user.st_tipo != 'P' && $store.state.user.st_tipo != 'X'">
      <div class="fixed-bottom row mx-1" v-if="pendencias && pendencias.length">
        <div class="col d-flex justify-content-end">
          <div class="alert carde ml-3" :class="'alert-' + ( tudo_branco ? 'light' : item.color )" v-for="(item, itx) in pendencias" :key="itx">
            <a href="#" @click.prevent="exibir_avisos()" class="alert-link" v-if="item.to && item.to.name == 'avisos'">
              {{ item.titulo }}
            </a>
            <router-link :to="item.to" class="alert-link" v-else>
              {{ item.titulo }}
            </router-link>
          </div>
        </div>
      </div>
    </template>

    <!-- Modal -->
    <div class="modal fade" id="bussolaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Bússola</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
            <div class="text-center">
              <a href="#" @click.prevent="tour()">
                <i class="far fa-compass fa-3x" aria-hidden="true"></i>
              </a>
            </div>
            <div class="text-center my-4">
              Sempre que visualizar o ícone da bússola na tela, ela poderá lhe guiar nos elementos da tela, facilitando seu aprendizado. <br>
              Experimente clicar nela!
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import $ from 'jquery';
import AzInput from './shared/forms/AzInput.vue';

export default {
  data() {
    return {
      textos: ['Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.'],
      pendencias: [],
      search: "", 
      tudo_branco: false, 
      modulos: [
        {
          title: "Call Center",
          path: "/call-center",
          icon: "far fa-calendar-alt",
          color: 'success',
          acesso: true, 
          perfil: 3,
          palavras: "Marcação, Agenda, Agendamento, Paciente, Orçamento, Bloqueio, Confirmação"
        },
        {
          title: "Recepção",
          name: "recepcao", 
          path: "/recepcao",
          icon: "fas fa-user-friends",
          color: "danger",
          acesso: true, 
          perfil: 4,
          palavras: "Atendimento, Paciente, Totem, Painel, CheckIn, Atestado"
        },
        {
          title: "Consultório",
          path: "/consultorio",
          icon: "fas fa-user-md",
          color: "secondary",
          acesso: true,
          perfil: 7,
          palavras: "Consulta, Anamnese, Paciente, Receita, Prescrição, Atestado"
        },
        {
          title: "Financeiro",
          path: "/financeiro/lancamento",
          icon: "fas fa-chart-pie",
          color: "warning text-dark",
          acesso: true,
          perfil: 5,
          palavras: "Fluxo de Caixa, Banco, Extrato, Pagamento, Conciliação, Nota Fiscal, Lançamento, Fornecedor, Impostos, DMED"  
        },
        {
          title: "Faturamento",
          name: 'guias', 
          path: '/faturamento/guias',
          icon: "fas fa-dollar-sign",
          color: "info",
          acesso: true,
          perfil: 8,
          palavras: "Guia, Fatura, TISS, SUS, BPA, APAC, Glosa, Recebimento, Arquivo Retorno"     
        },
        {
          title: "Suprimentos",
          path: "/suprimentos/atendimento",
          icon: "fas fa-box-open",
          color: "warning text-dark",
          acesso: true,
          perfil: 10,
          palavras: "Estoque, Compras, Material, Medicamento, Fornecedor, Inventário"   
        },
        {
          title: "Laudos",
          path: "/laudos/lista",
          icon: "fas fa-notes-medical",
          color: "secondary",
          acesso: true,
          perfil: 13,
          palavras: "Imagem"      
        },
        {
          title: "Assistência",
          path: "/assistencia/atend",
          icon: "fas fa-user-nurse",
          color: "secondary",
          acesso: true,
          perfil: 14,
          palavras: "Enfermagem, Infusão, Quimioterapia, Paciente"   
        },
        {
          title: "Repasse",
          name: "repasse",
          path: "/repasse/repasses",
          icon: "fas fa-hand-holding-usd",
          color: "light text-dark",
          acesso: true,
          perfil: 11,
          aba: 'repasses',
          palavras: "Pagamento, Rateio"      
        },
        {
          title: "Autorizações",
          path: "/autorizacoes/lista",
          icon: "fas fa-stamp",
          color: "success",
          acesso: true,
          perfil: 12,
          palavras: "Reembolso, Prévia, Online"         
        },
        {
          title: "Relatórios",
          path: "/relatorios",
          icon: "fas fa-info-circle",
          color: "primary",
          acesso: true,
          perfil: 9,
          palavras: "Informações, Dashboard, BI, Dados"
        },
        {
          title: "Configurações",
          name: "cadastros", 
          path: "/cadastros",
          icon: "fas fa-cog",
          color: "dark",
          acesso: true,
          perfil: 6, 
          palavras: "Regras, Parametrizações, Operadoras, Convênios, Médicos, Prestadores, Procedimentos, Usuários, Rateios, Agendas, Modelo, Cabeçalho, sulamerica, bradesco, unimed, amil, cnu, Permissões, Fila, Status, Tabelas, Preços"
        },
        {
          title: "CRM",
          path: "/crm",
          icon: "fab fa-gratipay",
          color: "success",
          acesso: true,
          perfil: 15,
          palavras: "Lead, Oportunidade"    
        },
        {
          title: "NPS",
          path: "/nps",
          icon: "far fa-smile",
          color: "primary",
          acesso: true,
          perfil: 17,
          palavras: "Satisfação, Promotores, Detratores, Neutros"    
        },
        {
          title: "Reembolso",
          name: "reembolso",
          aba: "reembolsos",
          path: "/reembolso/reembolsos",
          icon: "fas fa-search-dollar",
          color: "info",
          acesso: true,
          perfil: 18,
          palavras: "Acompanhamento"    
        },
        {
          title: "Internação",
          path: "/internacao/internados",
          icon: "fas fa-bed",
          color: "danger",
          acesso: true,
          perfil: 19,
          palavras: "Leito, Hospital, Day, Paciente"    
        },
        {
          title: "Centro Cirúrgico",
          path: "/centro-cirurgico/marcacao",
          icon: "fa-solid fa-house-medical",
          color: "success",
          acesso: true,
          perfil: 24,
          palavras: "Cirurgia, Procedimento, Sala, Paciente, Operatório, Paciente"    
        },
        {
          title: "Escalas",
          path: "/escalas/alocacao",
          icon: "fas fa-calendar-day",
          color: "success",
          acesso: true,
          perfil: 20,
          palavras: "Troca, Venda"    
        },
        {
          title: "Infusão",
          path: "/infusao/valid",
          icon: "fa-solid fa-circle-chevron-down",
          color: "success",
          acesso: true,
          perfil: 25,
          palavras: "Poltrona, Quimioterapia, Paciente"    
        },
        {
          title: "Vacina",
          path: "/vacina",
          icon: "fas fa-tint",
          color: "danger",
          acesso: true,
          perfil: 21,
          palavras: "Cartão, Paciente"    
        },
        {
          title: "Laboratório",
          path: "/laboratorio/visao",
          icon: "fas fa-vial",
          color: "secondary",
          acesso: true,
          perfil: 22,
          palavras: "Coleta"    
        },
        {
          title: "Contabilidade",
          path: "/contabilidade/planos",
          icon: "fa-solid fa-book",
          color: "warning text-dark",
          acesso: true,
          perfil: 27,
          palavras: "Contabilidade, Ativo, Passivo, Receita, Despesa, Patrimônio, Plano de Contas, Balanço, Razão, Diário, Livro, Contador"    
        },
        {
          title: "Nutrição",
          path: "/nutricao/pacientes",
          icon: "fa-solid fa-plate-utensils",
          color: "secondary",
          acesso: true,
          perfil: 30,
          palavras: "Nutrição, Dieta, Refeição, Cardápio, Paciente"    
        },
        {
          title: "Auditoria de Conta",
          path: "/auditoria/conta",
          icon: "fa-solid fa-clipboard-check",
          color: "info",
          acesso: true,
          perfil: 31,
          palavras: "Auditoria, Conta, Faturamento, Convênio"    
        },
        {
          title: "Bússola",
          action: this.exibir_bussola,
          icon: "far fa-compass",
          color: "primary",
          acesso: true,
          perfil: 0    
        },
        {
          title: "Avisos",
          action: this.exibir_avisos,
          icon: "fas fa-newspaper",
          color: "primary",
          acesso: this.$store.state.user.usa_avisos > 0,
          perfil: 0    
        },
        {
          title: "Contatos",
          path: "/contatos",
          icon: "fa-regular fa-address-book",
          color: "primary",
          acesso: true,
          perfil: 26    
        },
        {
          title: "Novidades",
          action: this.exibir_novidades,
          icon: "fa-solid fa-square-rss",
          color: "primary",
          acesso: true,
          perfil: 0    
        },
        {
          title: "Pesquisa Clínica",
          path: '/pesquisa-clinica',
          icon: "fas fa-laptop-medical",
          color: "primary",
          acesso: true,
          perfil: 23,
          palavras: "Informações"    
        },
        {
          title: "Cerimonial",
          path: '/cerimonial',
          icon: "fa-solid fa-bell-concierge",
          color: "danger",
          acesso: true,
          perfil: 28,
          palavras: "Cerimonial, Check-In, Totem, Recepção"    
        },
        {
          title: "Tempos",
          path: '/tempos/visao',
          icon: "fa-solid fa-stopwatch",
          color: "primary",
          acesso: true,
          perfil: 29,
          palavras: "Atendimento, Recepção, Tempo, TMA, TME"    
        },
        /*
        {
          title: "QOCKPIT",
          action: this.abrir_qockpit,
          icon: "fa-solid fa-q",
          color: "dark",
          acesso: true,
          perfil: 27,
          palavras: "QOCKPIT, Qualidade, Não Conformidade, Plano, Processos, Riscos, Documentos, Indicadores, Informações"    
        }
       {
          title: "Klyco",
          action: this.abrir_klyco,
          icon: "fa-solid fa-k",
          color: "dark",
          acesso: true,
          perfil: 5,
          palavras: "Klyco, Orçamento, Custos, Rateio, Centro de Custo, Demonstrativos"    
        },
        */
      ],

    };
  },

  components: { 
    AzInput, 
  },
  
  computed: { 
    lista: function () { 
      let search = this.search;

      if ( search ) { 

        if ( ( search.slice(0,1) == '#' || search.slice(0,1) == 'A' || search.slice(0,1) == 'M' ) && !isNaN(search.slice(1)) ) { 

          // search = 'Recepção';
          search = '/recepcao';

        } else { 

          let tags = search.match(/#[0-9]+/gi);

          if ( tags ) { 

            tags.forEach(tag => { 
              search = search.replace(tag, '');
            })

            search = search.trim();

            if ( search.toUpperCase().indexOf('REEMB') >= 0 ) { 
              search = 'Acompanhamento';
            }

          } else if ( search.indexOf('#') >= 0 ) { 

            search = search.replace('#', '').trim();

          }

        }

      }

      let reg = this.$util.getregex(search);

      return this.modulos.filter(item => item.acesso)
        .filter(item => !search || reg.test(JSON.stringify(item)));
    }
  },

  methods: {
    navegar(modulo) { 
        if ( !modulo ) { 
            console.log('Módulo não encontrado para navegação');
            return; 
        }

        console.log('Navegando para módulo:', modulo.name || modulo.path);

        this.$router.push({ name: modulo.name, path: modulo.path, params: { search: this.search, aba: modulo.aba ? modulo.aba : '' } })
            .then(() => console.log('push ok', modulo.name || modulo.path))
            .catch(err => console.error('push erro', modulo.name || modulo.path, err));
    },

    abrir_klyco () { 
        this.$util.load(this, { 
          service: 'klyco',
          func: 'acessar_sso',
          loadTo: (res) => { 
            if ( res && res.url ) { 
                window.open(res.url,'_blank');  
            }
          },
        });
    },

    abrir_qockpit() { 
      let token = this.axios.defaults.headers.post["Authorization"].slice(7);
      let url = 'http://' + window.redir + '.localhost:8001/klingo/sso?token=' + token;

      window.open(url,'_blank');
    },

    selecao() { 

      if ( this.lista && this.lista.length == 1 ) { 
        
        const modulo = this.lista[0];
      
        this.$router.push(
          { 
            name: modulo.name, 
            path: modulo.path, 
            params: { 
              search: this.search, 
              aba: modulo.aba ? modulo.aba : '' 
            } 
          }
        );

      }

    },

    teste() { 
      this.$util.atualizar(this, { 
        service: 'sus',
        func: 'exportar_apacs',
        dados: { 
          mes: '2020-07',
        },
        callback: (res) => { 
          var dataStr = "data:text/plain;charset=utf-8," + encodeURIComponent(res.conteudo);
          var downloadAnchorNode = document.createElement('a');
          downloadAnchorNode.setAttribute("href", dataStr);
          downloadAnchorNode.setAttribute("download", "APAC.TXT");
          document.body.appendChild(downloadAnchorNode); 
          downloadAnchorNode.click();
          downloadAnchorNode.remove();
        },
      });
    },
    print() { 
      const configPrint = {
        styles: [
          "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
          "https://api.klingo.app/css/estiloa4l.css",
        ]
      };
      this.$htmlToPaper("impressao", configPrint, () => {});
    },
    printTestSD() {
      this.$htmlToPaper("teste", () => {
        console.warn("Printing completed or was cancelled!");
      });
    },

    exibir_novidades() { 
      this.$router.push({ name: 'news' });
    },

    exibir_avisos() { 
      this.$util.exibir_todos_avisos();
    },

    exibir_bussola() { 
      $('#bussolaModal').modal('show');
    },

    tour() { 
      $('.modal').modal('hide');

      window.scrollTo(0,0);

      // Define the tour!
      var tour = {
          id: "hello-hopscotch",
          i18n: { 
                  doneBtn: "Pronto",
                  nextBtn: "Próximo",
                  prevBtn: "Anterior",
                  skipBtn: "Pular"
              },
          steps: [
              {
                  title: "Início",
                  content: "Clique aqui sempre que precisar retornar a tela inicial.",
                  target: "breadcrumb-home",
                  placement: "bottom"
              },
              {
                  title: "Busca Livre de Paciente",
                  content: "Caso se deseje consultar o histórico de um paciente, é possível utilizar esse campo para realizar a busca pelo nome ou CPF do paciente.",
                  target: "autocomplete-paciente",
                  placement: "bottom"
              },
              {
                title: "Chat",
                content: "Clique aqui para visualizar os usuários que estão on-line no sistema, para envio de mensagens de comunicação interna.",
                target: "botao-chat",
                placement: "left",
                yOffset: -20
              },
              {
                title: "Menu",
                content: "O círculo com as iniciais, apresenta um menu de contexto, para dentre outras coisas, acessar a opção de sair do sistema.",
                target: "navbarDropdown",
                placement: "left",
              },
              {
                title: "Módulos",
                content: "Essas caixas na tela inicial apresentam o link para os módulos do sistema. Clique nela para acessar o módulo.",
                target: "atalho-modulo",
                placement: "bottom",
              },
          ]
      };

      window.hopscotch.startTour(tour);

    },
  },
  created() {

    if ( this.$store.state.user.perfil_usuarios.find(item => { 
            return item.id_perfil == 2;
    }) ) { 

      return;

    }

    this.modulos.forEach(element => {
      if ( element.perfil ) { 
        if ( !this.$store.state.user.perfil_usuarios.find(item => { 
            return item.id_perfil == element.perfil;
        }) ) { 

          element.acesso = false;

        }
      }
    });
    
  },
  mounted() {
    this.$store.commit("setBreadcrumb", []);

    if ( this.$refs['pesquisa'] ) { 
      this.$refs['pesquisa'].$refs.input.focus ();
    }

    if ( this.$store.state.user.st_tipo != 'P' && this.$store.state.user.st_tipo != 'X' && this.$store.state.user.st_tipo != 'O' && this.$store.state.user.st_tipo != 'R' ) {

      this.$util.loadItem(this, { 
        service: 'usuarios',
        func: 'pendencias',
      })
      .then(res => { 
        this.pendencias = res;

        const avisos = res.find(item => item.avisos && item.avisos.length);

        if ( avisos ) { 
          this.$util.exibir_avisos(avisos.avisos);
        }
      });

    }

  },

};
</script>

<style scoped>
.atalho:hover {
  opacity: 0.9;
}

.atalho:hover i {
  -webkit-transition: opacity 0.2s ease-in;
  -moz-transition: opacity 0.2s ease-in;
  -o-transition: opacity 0.2s ease-in;
  transition: opacity 0.2s ease-in;
  opacity: 0;
}

.atalho:hover h3 {
  --font-size: 200%;
}

.atalho:hover h3 {
  -webkit-transform: translate3d(0, -30px, 0);
  transform: translate3d(0, -30px, 0);
}

.atalho:hover h3 {
  -webkit-transition-delay: 0.05s;
  transition-delay: 0.05s;
  -webkit-transition-duration: 0.35s;
  transition-duration: 0.35s;
}

.atalho i,
.atalho h3 {
  -webkit-transition: -webkit-transform 0.35s;
  transition: transform 0.35s;
}

body {
  background-image: url('../assets/fundo.webp');
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
}

.az-anime-surgir {
  animation: az-surgir 1s;
}

@keyframes az-surgir {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1) ease-in-out;
  }
}

</style>

